// Messages in the MRTS protocol, that are either sent to or received from MRTS
export const CONNECT_SCREEN = 'CONNECT_SCREEN';
export const START_GAME = 'START_GAME';
export const NEXT = 'NEXT';
export const PAUSE_RESUME = 'PAUSE_RESUME';
export const RESTART_ROOM = 's2';
export const GOTO_MAIN_SCOREBOARD = 's3';
export const RELOAD_CONTENT = 's11';
export const SET_NEXT_SCENE_BY_ID = 's12';
export const SCREEN_READY = 'SCREEN_READY';
export const SET_VOTE_VISIBILITY = 's19';
export const SET_PLAYLIST_AUTOUPDATE = 's21';

// Data payloads
export const DATA_QUESTION = 'DATA_QUESTION';
export const DATA_ROUND_RANKINGS = 'DATA_ROUND_RANKINGS';
export const DATA_RECENT_RESPONSES = 'DATA_RECENT_RESPONSES';
export const DATA_RECENT_CALLERS = 'DATA_RECENT_CALLERS';
export const DATA_CONTENT_MANIFEST = 's4';
export const DATA_RUN = 's13';
export const DATA_DEPLOYMENT_SETTINGS = 's14';
export const ADD_SCENE_TOTALS = 's15';
export const DATA_CONTENT = 's16';
export const DATA_SCENE = 's17';
export const DATA_GLOBAL = 's18';
export const DATA_STATE = 's20';

// Updates
export const UPDATE_STATE_INSTRUCTIONS = 'UPDATE_STATE_INSTRUCTIONS';
export const UPDATE_STATE_MAIN_COUNTDOWN = 'UPDATE_STATE_MAIN_COUNTDOWN';
export const UPDATE_STATE_ROUND = 'UPDATE_STATE_ROUND';
export const UPDATE_STATE_ROUND_ENDPAUSE = 'UPDATE_STATE_ROUND_ENDPAUSE';
export const UPDATE_STATE_MAIN_SCOREBOARD = 'UPDATE_STATE_MAIN_SCOREBOARD';
export const UPDATE_STATE_GAME_WINNER = 'UPDATE_STATE_GAME_WINNER';

// States
export const SET_STATE_INTRODUCTION            = 'SET_STATE_INTRODUCTION';
export const SET_STATE_INSTRUCTIONS            = 'SET_STATE_INSTRUCTIONS';
export const SET_STATE_MAIN_COUNTDOWN          = 'SET_STATE_MAIN_COUNTDOWN';
export const SET_STATE_MAIN_COUNTDOWN_ENDPAUSE = 'SET_STATE_MAIN_COUNTDOWN_ENDPAUSE';
export const SET_STATE_ROUND                   = 'SET_STATE_ROUND';
export const SET_STATE_ROUND_ENDPAUSE          = 'SET_STATE_ROUND_ENDPAUSE';
export const SET_STATE_ROUND_SCOREBOARD        = 'SET_STATE_ROUND_SCOREBOARD';
export const SET_STATE_GAMEOVER                = 'SET_STATE_GAMEOVER';
export const SET_STATE_GAME_WINNER             = 'SET_STATE_GAME_WINNER';
export const SET_STATE_MAIN_SCOREBOARD         = 'SET_STATE_MAIN_SCOREBOARD';
export const SET_STATE_INTERMISSION            = 'SET_STATE_INTERMISSION';
